export default __webpack_public_path__ + "static/media/17c446f724d00c7a3267af6ea86b2b8d.jpg";